import React from "react";
import { Card } from "@/components/ui/card";

export const RevisionsTab = ({ revisions }) => (
  <div className="space-y-4">
    {(revisions || []).length === 0 ? (
      <Card className="p-6 text-sm text-muted-foreground">No revisions yet.</Card>
    ) : revisions.map((rev) => (
      <Card key={rev.id} className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-mono text-xs text-muted-foreground">Revision #{rev.revision_number}</div>
            <div className="text-sm mt-1">by {rev.source || "admin"} · {new Date(rev.created_at).toLocaleString()}</div>
          </div>
        </div>
        <details className="mt-2 text-xs">
          <summary className="cursor-pointer text-muted-foreground">View snapshot</summary>
          <pre className="mt-2 max-h-64 overflow-auto bg-secondary p-3 rounded font-mono text-[11px]">{JSON.stringify(rev.snapshot, null, 2)}</pre>
        </details>
      </Card>
    ))}
  </div>
);
